module.exports = __webpack_public_path__ + "src/assets/img/Saly-1.7b773bf6.webp";